module.exports = __webpack_public_path__ + "static/media/home.8af24aaf.svg";